const BLOCKED_DOMAINS = new Set([
  'doubleclick.net',
  'googlesyndication.com',
  'google-analytics.com',
]);

const isBlockedDomain = (hostname: string): boolean => {
  if (BLOCKED_DOMAINS.has(hostname)) {
    return true;
  }

  for (const domain of BLOCKED_DOMAINS) {
    if (hostname.endsWith(`.${domain}`)) {
      return true;
    }
  }

  return false;
};

export default isBlockedDomain;
